import {
    AutocompleteInput,
    DateInput,
    ListProps,
    NullableBooleanInput,
    ReferenceInput,
    SelectArrayInput,
} from "ra-ui-materialui";
import {initField} from "../../shared/utils";
import {useOptions} from "../../shared/hooks/useOptions";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {TariffType} from "../../shared/types";
import {PurchaseChargesList} from "../components/ChargesList/PurchaseChargesList";
import {PurchaseBulkActions} from "./components/PurchaseBulkActions";
import {ValidatedBar} from "../CalculateChargesList/components/ValidatedBar";

export const VerifiedPurchaseChargesList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const { data: optionsTariff } = useOptions("tariffs", "GET");
  const filters =
    options && optionsTariff
      ? [
        <DateInput
          source="charge_date_after"
          label="Dal"
          alwaysOn
          required
        />,
        <DateInput
          source="charge_date_before"
          label="Al"
          alwaysOn
          required
        />,
        <ReferenceInput
          {...initField("delivery", options)}
          reference="autocomplete/delivery"
        >
          <AutocompleteInput optionText="label" />
        </ReferenceInput>,
        <ReferenceInputSubject
          filter={{ type: "client" }}
          {...initField("client", options)}
        />,
        <ReferenceInputSubject
          filter={{ type: "supplier" }}
          {...initField("supplier", options)}
          alwaysOn
        />,
        <SelectArrayInput
          style={{ minWidth: "155px" }}
          choices={optionsTariff.charge_type.choices}
          {...initField("charge_type", optionsTariff, "array")}
        />,
        <NullableBooleanInput
          source="reconciliation_date_not_null"
          label="Riconciliati"
          className="filter-field-small"
          alwaysOn
        />,
        <DateInput
          source="reconciliation_date_after"
          label="Riconciliati dal"
        />,
        <DateInput
          source="reconciliation_date_before"
          label="Riconciliati al"
        />,
      ]
      : [];

  return (
    <>
      <ValidatedBar />
      <PurchaseChargesList
        {...props}
        Actions={PurchaseBulkActions}
        filters={filters}
        filter={{
          verified: true,
          no_invoice: true,
          no_page: true,
          tariff_type: TariffType.PURCHASE
        }}
      />
    </>
  );
};
